import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetListGeneralResultParams {
	company_id: string;
	organization_id: string;
	report_id: string;
	locale: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetListGeneralResults = (params: GetListGeneralResultParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.report_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_RESOLUTION_886_GENERAL_RESULT, params],
		queryFn: async () => Service.getListGeneralResult(params),
		enabled: isEnabled
	});
};
